/**
 * Lê o `step` da query string do deep link gerado pelo QR Code do PDF impresso.
 *
 * O PDF gera um QR por passo do estudo de caso, no formato
 * `/qr/question/{id_questao}?curso={id}&step={question_steps.id}`. O valor é o id
 * do passo no banco, não o índice dele na lista.
 *
 * Devolve `undefined` para qualquer valor que não seja um id plausível, para que
 * a tela caia no comportamento padrão (abrir no primeiro passo) em vez de quebrar.
 */
export const parseStepIdFromSearch = (search: string): number | undefined => {
  const raw = new URLSearchParams(search).get('step');

  if (raw === null || raw.trim() === '') {
    return undefined;
  }

  const parsed = Number(raw);

  return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
};
